"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchJSON = void 0;
const tslib_1 = require("tslib");
function buildFetchJSONError(message, status, statusText) {
    const error = new Error(message);
    Object.defineProperties(error, {
        status: {
            value: status,
        },
        statusText: {
            value: statusText,
        },
    });
    return error;
}
/**
 * Execute a HTTP request against a given endpoint using a JSON formatted payload.
 * @public
 *
 * @param endpoint - A url to execute the request against.
 * @param param1 - The request configuration including headers, tokens, method, body as well as extra configuration used in native fetch function {@link RequestInit}
 * @param timeout - How much time (milliseconds) we should wait for the request to complete before giving up.
 *
 * @returns The response if request reached the endpoint otherwise this function will reject the request.
 *
 * @remarks
 * You should handle any HTTP error codes by using the `ok` or `status` field once the request is resolved. It's important also to validate
 * the type of the data returned as an empty `body` is considered as valid, if status is `200`.
 *
 * @example
 * ```ts
 * const getPosts = fetchJSON('https://jsonplaceholder.typicode.com/posts/1');
 * const postPosts = fetchJSON('https://jsonplaceholder.typicode.com/posts', {
 *   body: {
 *     userId: 1,
 *     title: 'HC',
 *     body: 'Styleguide is cool',
 *   },
 * });
 * const putPosts = fetchJSON('https://jsonplaceholder.typicode.com/posts/1', {
 *   body: {
 *     userId: 2,
 *     title: 'HC',
 *     body: 'Styleguide is awesome',
 *   },
 *   method: 'PUT',
 * });
 * const patchPostsWithTokenAndHeaders = fetchJSON(
 *   'https://jsonplaceholder.typicode.com/posts/1',
 *   {
 *     body: {
 *       body: 'Talk is cheap show me the code',
 *     },
 *     method: 'PATCH',
 *     token: 'asfsdfdsfsadfasdfa',
 *     headers: {
 *       Accept: 'application/json',
 *     },
 *   },
 * );
 * ```
 */
function fetchJSON(endpoint, _a = {}, timeout) {
    var { body, token, headers: customHeaders } = _a, customConfig = (0, tslib_1.__rest)(_a, ["body", "token", "headers"]);
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
        const temp = { method: 'GET' };
        const headers = {};
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        if (body) {
            temp.method = 'POST';
            temp.body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }
        const config = Object.assign(Object.assign(Object.assign({}, temp), { headers: Object.assign(Object.assign({}, headers), customHeaders) }), customConfig);
        return new Promise((resolve, reject) => {
            if (typeof timeout !== 'undefined' && timeout > 0) {
                setTimeout(() => {
                    reject(buildFetchJSONError('Request take too long to complete', 408, 'Request timeout'));
                }, timeout);
            }
            fetch(endpoint, config).then(resolve, reject);
        }).then((response) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (!response.ok) {
                return Promise.reject(buildFetchJSONError(yield response.text(), response.status, response.statusText));
            }
            const contentType = response.headers.get('content-type');
            const isJsonType = contentType && contentType.includes('application/json');
            const parsedBodyPromise = isJsonType ? response.json() : response.text();
            response.parsedBody = yield parsedBodyPromise;
            return response;
        }));
    });
}
exports.fetchJSON = fetchJSON;
//# sourceMappingURL=fetch-JSON.js.map